import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { Sketch } from 'vue-color';
import tinycolor from 'tinycolor2';

export default Vue.component('solid-color-option', {
  template: require('./template.html'),
  name: 'solid-color-option',
  computed: {
    ...mapGetters(['viewport', 'activeDroplet', 'activeDropletItem']),
    schemeColors() {
      return [{ color: '', type: 'picker' }];
    },
  },
  components: {
    'sketch-picker': Sketch,
  },
  props: [
    'option',
    'active-state',
    'dom-nodes',
    'bg-type',
    'component-config',
    'default-values',
    'areas',
    'areaChecked',
  ],
  data() {
    return {
      pickerVals: {},
      colorPickers: {},
    };
  },
  watch: {
    viewport() {
      this.setInitialValue();
    },
    activeState() {
      this.setInitialValue();
    },
    activeDropletItem: {
      handler() {
        this.setInitialValue();
      },
      deep: true,
    },
  },
  created() {
    // setup defaults from payload models
    _.forOwn(this.option.payload.models, (model, name) => {
      let value = model.default;
      if (name === 'pickerVals') {
        value = this._defaultColorPickerObj;
      }
      if (this[name]) {
        this.$set(this[name], model.name, value);
      }
    });
    // then check for previous values
    this.setInitialValue();
  },
  methods: {
    colorPickerChange(params) {
      const value = this.pickerVals[params.models.pickerVals.name];
      this.$emit('update-styles', {
        ...params,
        solidVal: this._concatPicker(value),
      });
    },
    setInitialValue() {
      const option = _.cloneDeep(this.option);
      const $vm = {
        viewport: this.viewport,
        droplet: this.activeDroplet,
      };
      let rule = option.payload.updates[0];
      // if one area is checked, get that rule from the updates list
      if (this.areaChecked) {
        const checked = _.keys(_.pickBy(this.areas));
        rule = _.find(option.payload.updates, update => checked.includes(update.property));
      }
      let selector;
      if (this.activeDropletItem._id && this.componentConfig.itemList) {
        const inner = this.componentConfig.itemList.selectors[rule.property];
        const nested = inner || '';
        selector = `#drp-${this.activeDropletItem._id}${nested}${this.activeState}`;
      } else {
        selector = rule.selector.replace(/\$\{state\}/gi, this.activeState);
        selector = selector.replace(/\$\{dropletId\}/gi, this.activeDroplet._id);
      }
      const property = rule.property;
      const useRoot = option.$el === 'root';
      const $root = this.domNodes.$dropletRow;
      const $el = useRoot ? $root : $root.querySelectorAll(option.$el)[0];
      this.pickerVals[option.payload.models.pickerVals.name] = this._getPickerVal(
        $vm,
        selector,
        property,
        $el,
      );
    },
    shadeHelper(val) {
      const color = tinycolor(val);
      let shade;
      if (color.isDark()) {
        shade = color.lighten(30).toString();
      } else {
        shade = color.darken(30).toString();
      }
      return shade;
    },
    toggleColorPicker(type) {
      _.forOwn(this.colorPickers, (value, key) => {
        if (type && key !== type) {
          this.colorPickers[key] = false;
        } else if (!type) {
          this.colorPickers[key] = false;
        }
      });
      if (type) {
        this.colorPickers[type] = !this.colorPickers[type];
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/style-sidebar/options/background-options/solid/index.js